import { render } from "./search-flight-header.vue?vue&type=template&id=e594f470&ts=true"
import script from "./search-flight-header.vue?vue&type=script&lang=ts"
export * from "./search-flight-header.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__